import { useEvent, useStore } from 'effector-react/compat'
import { $errorMessage, addErrorMessage, deleteErrorMessage } from '@entities/error-message/model'

export const useErrorMessage = () => useStore($errorMessage)
export const useAddErrorMessage = () => useEvent(addErrorMessage)
export const useDeleteErrorMessage = () => useEvent(deleteErrorMessage)
